import styles from "./style.module.scss";
import { Tooltip } from "react-tippy";
import { Input } from "reactstrap";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { ChangeEvent, ReactNode, useEffect, useState } from "react";
import { FOUR_PRICES_MANAGEMENT_CODE } from "@utils/Constants";
import { PriceApi, PriceDataType } from "@/api/PricesApi";
import { setPrice, setPriceCode } from "@/store/slices/eDocumentSlides";
import { removeFunctionFromObject } from "@utils/Utils";

type PriceSelectorProps = {
};

const PriceSelector = (props: PriceSelectorProps) => {
  const { } = props;
  const dispatch = useAppDispatch()
  const suscriptionData = useAppSelector((state) => state.suscription.suscription);
  const [pricesData, setPricesData] = useState<PriceDataType[]>([])
  const [priceOptions, setPriceOptions] = useState<Record<string, string>>({})
  const priceCode = useAppSelector((state) => state.eDocument.priceCode);
  const priceId = useAppSelector((state) => state.eDocument.priceData?.id);

  useEffect(() => {
    suscriptionData
    if (suscriptionData?.pricemanaged === FOUR_PRICES_MANAGEMENT_CODE) {
      setPriceOptions({
        "1": "P1",
        "2": "P2",
        "3": "P3",
        "4": "P4",
      })
      dispatch(setPriceCode(1))
    } else {
      loadSuscriptionPrices();
    }
  }, [])

  const loadSuscriptionPrices = async () => {
    const { items } = await PriceApi.fetchAll();
    setPricesData(items)
    const dynamicPriceOptions = items.filter(i => !!i.number)
      .sort((a, b) => Number(a.number) - Number(b.number))
      .reduce((a, v) => {
        return {
          ...a,
          [`${v.id}`]: `P${v.number}`
        }
      }, {} as Record<string, string>)

    const defaultprice = items.find(p => p.default)
    if (defaultprice) {
      setPriceOnStore(defaultprice)
    }
    setPriceOptions(dynamicPriceOptions);
  }

  const generateSelectOptions = (): ReactNode[] => {
    return Object.entries(priceOptions).map(([value, label]) => {
      return (<option value={value}>
        {label}
      </option>)
    })
  }

  const onPriceChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const priceCode = Number(value)
    if (isNaN(priceCode)) {
      const priceData = pricesData.find(p => p.id === value);
      if (priceData) {
        setPriceOnStore(priceData)
      }
    } else {
      dispatch(setPriceCode(priceCode))
    }
  }

  const setPriceOnStore = (priceData: PriceDataType) => {
    const data = removeFunctionFromObject(priceData)
    dispatch(setPrice(data))
  }

  const getSelectedPrice = (): string | undefined => {
    if (suscriptionData?.pricemanaged === FOUR_PRICES_MANAGEMENT_CODE) {
      return `${priceCode}`
    } else if (priceId) {
      return priceId
    }
  }

  return (
    <>
      <Tooltip
        title="Tipo de Precio Documento"
        trigger="mouseenter"
      >
        <Input
          id="priceSelector"
          type="select"
          title="Tipo de Precio Documento"
          onChange={onPriceChange}
          value={getSelectedPrice()}
        >
          {generateSelectOptions()}
        </Input>
      </Tooltip>
    </>
  )
}

export default PriceSelector;